import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { ScheduleListComponent } from './schedule-list/schedule-list.component';
import { ScheduleComponent } from './schedule.component';
import { ScheduleEditComponent } from './schedule-edit/schedule-edit.component';
import { ScheduleRoutingModule } from './schedule-routing.module';
import { CommonModule } from '@angular/common';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClientParentModule } from '../client-parent/client-parent.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';

@NgModule({
    declarations: [
        ScheduleListComponent,
        ScheduleComponent,
        ScheduleEditComponent
    ],
  
    imports: [
        ScheduleRoutingModule,
        CommonModule,
        GridModule,
        MyDatePickerModule,
        ReactiveFormsModule,
        ClientParentModule,
        FormsModule,
        NgSelectModule,
        NgxUiLoaderModule,
        MaskedTextBoxModule,   
    ],
    schemas:[NO_ERRORS_SCHEMA]
})
export class ScheduleModule { }
